<template>
    <div class="card pipeline-list p-2">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Customer Details</th>
                        <th>Deal Title</th>
                        <th>Deal Open Date</th>
                        <th>Deal Number</th>
                        <th>Source</th>
                        <th>Required Product / Services</th>
                        <th>Deal Assign To</th>
                        <th>Deal Stage</th>
                        <th>Deal Description</th>
                        <th>Tag</th>
                        <th>Quotation Info</th>
                        <th>Open Task</th>
                        <th>Schedule Date & Time</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in pipelineList" :key="index">
                        <td>
                            <p><strong>{{ item.contact_profile_name }}</strong></p>
                            <p>{{ item.contact_profile_location }}</p>
                            <p>{{ item.contact_profile_phone }}</p>
                        </td>
                        <td>{{ item.deal_title }}</td>
                        <td>{{ item.created_at.split('T')[0] }}</td>
                        <td>{{ item.deal_number }}</td>
                        <td>
                            <p><strong>Source - {{ item.deal_source_name }}</strong></p>
                            <p>Campaign / Project - {{ item.project_name }}</p>
                            <p>Deal Owner - {{ item.deal_owner_name }}</p>
                        </td>
                        <td>
                            <p>Product - {{ getCommaData(item.products) }}</p>
                            <p>Est Deal Value: {{ item.est_deal_value }}</p>
                            <p>Probability (%) of winning - {{ item.probability }}</p>
                        </td>
                        <td>{{ item.deal_assign_name }}</td>
                        <td>{{ item.deal_stage_name }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ getCommaData(item.tag_registers) }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <button class="btn btn-primary btn-sm"
                                @click="goToEdit(item.id)"
                                style="cursor: pointer"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p v-if="!pipelineList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps({
    pipelineList: Array,
})

const getCommaData = (data) => {
    if(! data ) {
        return;
    }
    return data.map(p => p.name).join(', ');
}

const goToEdit = (id) => {
    const params = { ...route.params }
    params.salePipelineId = id;

    router.push({
        name: 'edit-deal',
        params: params,
        query: route.query,
    })
}
</script>

<style scoped>
.pipeline-list{
    min-height: 200px
}
</style>